import { useMutation } from '@tanstack/react-query';

import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../../logic';
import { ApiErrorResponse } from '../../../../types';
import { postAnalyseAttachmentForFraud } from '../../requests/postAnalyseAttachmentForFraud';

export const useAnalyseAttachmentForFraud = (definitionName: string) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: analyseAttachmentForFraud, ...rest } = useMutation({
    mutationFn: (attachmentId: string) =>
      postAnalyseAttachmentForFraud(
        constructPost,
        attachmentId,
        definitionName,
      ),
    onSuccess: () => handleSuccess('Fraud rescan initiated successfully'),
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'Failed to rescan for fraud')),
  });

  return { analyseAttachmentForFraud, ...rest };
};
